import type { InsightsChannel } from "@hightouch/lib/ad-studio/insights-channels/registry";
import googleLogo from "src/components/logos/google.svg";
import linkedinLogo from "src/components/logos/linkedin.svg";
import metaLogo from "src/components/logos/meta.svg";
import tiktokLogo from "src/components/logos/tiktok.svg";
import type { AdEntityType } from "src/pages/ad-studio/insights/shared/types";

export type { InsightsChannel };

const CHANNEL_LOGOS = new Map<InsightsChannel["sourceType"], string>([
  ["facebook_ads", metaLogo],
  ["google_ads", googleLogo],
  ["linkedin_ads", linkedinLogo],
  ["tiktok_ads", tiktokLogo],
]);

/** The channel's logo by its insights source type, when there is one. */
export const insightsChannelLogo = (sourceType: string): string | undefined =>
  CHANNEL_LOGOS.get(sourceType);

// Shown while the sync list is loading or the sync is unknown.
const FALLBACK_ENTITY_LABELS: Record<AdEntityType, string> = {
  campaign: "Campaign",
  ad_set: "Ad set",
  ad: "Ad",
};

/** Display label for a grouping level, from the channel registry. */
export function getEntityLabel(
  channel: InsightsChannel | undefined,
  entityType: AdEntityType,
): string {
  return (
    channel?.entityLabels[entityType] ?? FALLBACK_ENTITY_LABELS[entityType]
  );
}
